/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

//window.Vue = require('vue');
//import Vue from 'vue';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
/*
const app = new Vue({
    el: '#app',
});
*/

///////////////////////////////////////////////////////////////// メニューボタン
$(function () {
    // メニュー開閉
    $(document).on("click", function (e) {

        if ($(e.target).closest('#mobile_menu_btn').length) {
            // メニューボタンクリック時
            if ($('.content_menu_box').hasClass('content_menu_box_open')) {
                closeContent_menu();
            } else {
                openContent_menu();
            }
        } else {
            // それ以外クリック時
            if (!$(e.target).closest('.content_menu_box').length) {
                if ($('.content_menu_box').hasClass('content_menu_box_open')) {
                    closeContent_menu();
                }
            }
        }
    });

    ///////////////////////////////////////////////////////////// メニューを左にスワイプでメニューを閉じる
    let startX = null;
    let startY = null;
    let endX = null;
    let endY = null;

    $(document).on("touchmove", function (e) {
        if ($(e.target).closest('.content_menu_box_open').length) {
            logSwipe(e);
        }
    });
    $(document).on("touchstart", function (e) {
        if ($(e.target).closest('.content_menu_box_open').length) {
            logSwipeStart(e);
        }
    });
    $(document).on("touchend", function (e) {
        if ($(e.target).closest('.content_menu_box_open').length) {
            logSwipeEnd(e);
        }
    });
    
    function logSwipeStart(event) {
        //event.preventDefault();
        startX = event.touches[0].pageX;
        startY = event.touches[0].pageY;
    }

    function logSwipe(event) {
        //event.preventDefault();
        endX = event.touches[0].pageX;
        endY = event.touches[0].pageY;
    }

    function logSwipeEnd(event) {
        //event.preventDefault();

        if (Math.abs(endX - startX) > Math.abs(endY - startY)) {
            if (0 > (endX - startX)) {
                closeContent_menu();
            }
        }
    }
    /////////////////////////////////////////////////////////////
});

function openContent_menu() {

    // 遅延表示
    $('.footer_menu').fadeOut(0);
    setTimeout(function () {
        $('.footer_menu').fadeIn();
    }, 250);

    $('.content_menu_box').css({
        'width': '0%',
    });
    $('.content_menu_box').removeClass('hideFooterMenu');
    $('.content_menu_box').addClass('content_menu_box_open');
    
    $('.content_menu_box').css({
        'transition': 'width 0.5s',
        'top': $('nav').height(),
        'width': '100%',
        'height': $(window).outerHeight() - $('nav').height(),
    });

    // ウィンドウサイズを変更したら
    $(window).on("resize", function () {
        if ($('.content_menu_box').hasClass('content_menu_box_open')) {
            $('.content_menu_box').css({
                'top': $('nav').height(),
                'height': $(window).outerHeight() - $('nav').height(),
            });
        }
    });

    // メニュー外のクリックを禁止
    $('main').css('pointer-events', 'none');
}

function closeContent_menu() {

    $('.footer_menu').fadeOut(150);
    setTimeout(function () {
        $('.footer_menu').fadeIn();
    }, 500);

    $('.content_menu_box').css({
        'width': '0%',
    });

    setTimeout(function () {
        resetFooterMenu();
        switchFooterMenu();
    }, 500);

    // メニュー外のクリックを禁止を解除
    $('main').css('pointer-events', 'auto');
}
function resetFooterMenu() {
    $('.content_menu_box').css({
        'transition': 'width 0s',
        'top': '0',
        'width': '100%',
        'height': 'auto',
    });
    $('.content_menu_box').removeClass('content_menu_box_open');
}
function switchFooterMenu() {
    if (!$('.content_menu_box').hasClass('content_menu_box_open')) {
        if ($(window).width() < 768) {
            $('.content_menu_box').addClass('hideFooterMenu');
        } else {
            $('.content_menu_box').removeClass('hideFooterMenu');
            resetFooterMenu();
        }
    }
}

$(function () {

    switchFooterMenu();

    // ウィンドウサイズを変更したら
    $(window).on("resize", function () {
        switchFooterMenu();
    });
});


$(function () {

    // フェードイン要素をフェードイン
    $('.fade_in').fadeIn();

    // ツールチップ表示
    $('[data-toggle="tooltip"]').tooltip()
        // クリック時の動作を設定
        .on('click', function () {
            $(this).tooltip('hide'); // Tooltipを表示しない
        });

    // mainの最低高さ
    setMain_height();
    // ウィンドウサイズを変更したら
    $(window).on("resize", function () {
        setMain_height();
    });
});

// mainの最低高さ設定
function setMain_height() {
    $('main').css({
        'min-height': window.innerHeight - $('.headerSpace').eq(0).height(),
    });
}

// フォーム送信時ローディング表示
$(function () {
    let forms = document.getElementsByTagName("form");

    Array.from(forms).forEach(form => {
        form.addEventListener("submit", function (event) {
            $('#loading_box').fadeIn();
        });
    });
});
